<template>
  <div class="move-to-folder p-4 pt-0">
    <ul class="breadcrumbs mb-6 flex">
      <li v-if="breadcrumbs.length > visibleBreadcrumbs.length">
        ...
      </li>
      <li v-for="breadcrumb of visibleBreadcrumbs" :key="breadcrumb._id">
        <ChevronRight
          class="inline-block h-2 w-auto mx-2"
          v-if="!breadcrumb.root"
        />

        <button
          type="button"
          @click="back(breadcrumb._id)"
          class="breadcrumb-item text-gray-900 text-lg overflow-hidden"
          :title="breadcrumb.name"
        >
          {{ breadcrumb.name }}
        </button>
      </li>
    </ul>
    <div
      class="browser border border-gray-400 h-50 overflow-y-auto"
      v-if="currentFolder"
    >
      <ApolloQuery
        :query="browseQuery"
        :variables="browseVariables"
        :key="currentFolderId"
      >
        <template v-slot="{ result: { loading, error, data } }">
          <div v-if="loading">Caricamento...</div>
          <div v-else-if="error">
            Errore durante il caricamento.
          </div>
          <ul
            v-else-if="
              data && data.foldersByParent && data.foldersByParent.data
            "
          >
            <li
              v-for="folder of data.foldersByParent.data"
              :key="folder._id"
              class="folder-item border-b border-gray-400"
            >
              <button
                type="button"
                class="flex p-4 w-full"
                :disabled="isDisabled(folder._id)"
                @click="loadFolder(folder)"
              >
                <IconFolder class="inline-block h-3 w-auto mr-2" />
                {{ folder.name }}
              </button>
            </li>
          </ul>
        </template>
      </ApolloQuery>
    </div>
    <div class="actions mt-7">
      <button
        type="button"
        class="btn-default"
        v-if="currentFolder"
        :disabled="routingCurrentFolder === currentFolderId"
        @click="$emit('move', currentFolderId)"
      >
        {{ `Sposta in ${currentFolder.name}` }}
      </button>
    </div>
  </div>
</template>

<script>
import GET_FOLDER_DATA from '@/graphql/GetFolderData.gql'
import GET_ROOT_FOLDER from '@/graphql/GetRootFolder.gql'
import ChevronRight from '@/assets/icons/icon-chevron_right.svg'
import IconFolder from '@/assets/icons/icon-folder.svg'

export default {
  components: {
    ChevronRight,
    IconFolder,
  },

  data() {
    return {
      breadcrumbs: [],
      currentFolder: null,
      browseQuery: GET_FOLDER_DATA,
    }
  },

  computed: {
    browseVariables() {
      return {
        id: this.currentFolderId,
      }
    },
    visibleBreadcrumbs() {
      return this.breadcrumbs.slice(-3)
    },
    currentFolderId() {
      return this.currentFolder ? this.currentFolder._id : ''
    },
    checkedFolders() {
      return this.$store.state.folders.checkedFolders
    },
    routingCurrentFolder() {
      return this.$store.state.folders.currentFolder
    },
  },

  async created() {
    const { data } = await this.$apollo.query({
      query: GET_ROOT_FOLDER,
    })

    this.loadFolder({
      ...data.rootFolder,
      name: 'Tutte',
      root: true,
    })
  },

  methods: {
    back(id) {
      const index = this.breadcrumbs.findIndex(br => br._id === id)
      if (index >= 0) {
        this.breadcrumbs = this.breadcrumbs.slice(0, index + 1)
        this.currentFolder = this.breadcrumbs[index]
      }
    },

    loadFolder(folder) {
      this.breadcrumbs.push(folder)
      this.currentFolder = folder
    },

    isDisabled(id) {
      return this.checkedFolders.some(folderId => folderId === id)
    },
  },
}
</script>

<style lang="scss" scoped>
.breadcrumb-item {
  text-overflow: ellipsis;
  max-width: 120px;
  white-space: nowrap;
}

.folder-item {
  &:last-child {
    @apply border-none;
  }

  button[disabled] {
    @apply opacity-25;
  }
}
</style>
